import { formatDistanceToNow, format, isPast, parseISO } from 'date-fns';
import { es } from 'date-fns/locale';

/**
 * Formatea una fecha ISO como "15 jun 2025"
 */
export function formatDate(iso: string): string {
  return format(parseISO(iso), 'd MMM yyyy', { locale: es });
}

/**
 * Formatea tiempo relativo: "hace 3 dias"
 */
export function formatRelativeTime(iso: string): string {
  return formatDistanceToNow(parseISO(iso), { addSuffix: true, locale: es });
}

/**
 * Formatea una fecha de vencimiento (deadline YYYY-MM-DD).
 * "Vence 20 jul" si es futuro, "Vencio hace 3 dias" si ya paso.
 * El deadline se interpreta como fecha local (sin zona horaria).
 */
export function formatDeadline(deadline: string): string {
  // Parsear como local: YYYY-MM-DD → midnight local
  const [year, month, day] = deadline.split('-').map(Number);
  const date = new Date(year, month - 1, day);

  if (isPast(date)) {
    const relative = formatDistanceToNow(date, { addSuffix: true, locale: es });
    return `Vencio ${relative}`;
  }

  const formatted = format(date, 'd MMM', { locale: es });
  return `Vence ${formatted}`;
}

/**
 * Formatea como "jun 2025" (mes abreviado + anio)
 */
export function formatShortDate(iso: string): string {
  return format(parseISO(iso), 'MMM yyyy', { locale: es });
}

/**
 * Fecha local del usuario como YYYY-MM-DD. Se envía en las mutaciones para que
 * la gamificación (rachas, stats diarias) use el día del usuario y no UTC.
 */
export function getLocalDate(): string {
  const d = new Date();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${month}-${day}`;
}
